import { render } from "./ClusterIconMenu.vue?vue&type=template&id=39372e16&scoped=true"
import script from "./ClusterIconMenu.vue?vue&type=script&lang=js"
export * from "./ClusterIconMenu.vue?vue&type=script&lang=js"

import "./ClusterIconMenu.vue?vue&type=style&index=0&id=39372e16&lang=scss&scoped=true"
import "./ClusterIconMenu.vue?vue&type=style&index=1&id=39372e16&lang=scss"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39372e16"]])

export default __exports__